export default __webpack_public_path__ + "static/assets/d0de3dbfb3730707467d01f8f0cb4c53.png";